// download login form
const $downloadForm = document.getElementById('downloadLoginForm');

if ($downloadForm !== null) {
    const $conditionsCheckbox = $downloadForm.querySelector('input[type=checkbox]');
    const $submitButton = $downloadForm.querySelector('[type=submit]');
    const cookieName = 'leaDownloadsLoggedIn';

    // check if cookie is set
    if (getCookie(cookieName) === 'true') {
        showDownloads();
    }

    // check that conditions are checked
    $conditionsCheckbox.addEventListener('change', (e) => {
        if ($conditionsCheckbox.checked === true) {
            $submitButton.disabled = false;
        } else {
            $submitButton.disabled = true;
        }
    });

    // deal with submitting the form
    $downloadForm.addEventListener('submit', (e) => {
        e.preventDefault();
        checkDownloadLogin($downloadForm).then((answer) => {
            if (answer.status !== 200) return showDownloadFormError('Fehler: Falsche Anmeldedaten');

            // ok: set cookie and show downloads
            setCookie(cookieName, 3, 'true');
            showDownloads();
        }, showDownloadFormError);
    });

    /**
     * show an error in a notification
     * @param message
     * @return {boolean}
     */
    function showDownloadFormError(message = '') {
        const notification = $downloadForm.querySelector('.notification');
        notification.classList.remove('is-hidden');
        if (message !== '') {
            notification.querySelector('.text').textContent = message;
        }
        return false;
    }

    /**
     * renders actual html into page
     * @return {void}
     */
    function showDownloads() {
        // hide form
        $downloadForm.classList.add('hide');

        // render html
        const $container = document.getElementById('downloadMarkup');

        getDownloads().then((downloads) => downloads.json()).then((downloads) => {
            for (const category in downloads) {
                const category_downloads = downloads[category];

                $container.innerHTML += `<h2 class="subtitle">${category}</h2>`;
                for (const download_id in category_downloads) {
                    const download = category_downloads[download_id];
                    let files = '';
                    for (const file_id in download.file) {
                        const file = download.file[file_id];
                        files += `       <a class="downloadLink is-narrow" target="_blank" href="${window.baseUrl}${file.filepath}">`
                            + `           ${file.extension.toUpperCase()} (${file.fileSize})`
                            + '       </a>';
                    }

                    $container.innerHTML += ''
                        + '<div class="downloadsEntry columns is-multiline">'
                        + `   <div class="downloadId column is-narrow" style="min-width: 3rem;">${download_id}</div>`
                        + `   <div class="downloadTitle column">${download.title}</div>`
                        + `   <div class="downloadFiles column is-narrow">${files}</div>`
                        + '</div>';
                }
            }
        });
    }

    /**
     *
     * @return {Promise<Response>}
     */
    async function getDownloads() {
        return await window.fetch(`${window.baseUrl}downloads_json`, {
            method: 'GET',
        });
    }

    /**
     *
     * @param $downloadForm
     * @return {Promise<Response>}
     */
    async function checkDownloadLogin($downloadForm) {
        return await window.fetch(`${window.baseUrl}download_credential_check`, {
            method: 'POST',
            cache: 'no-cache',
            body: new FormData($downloadForm),
        });
    }

    /**
     *
     * @param name {string}
     * @param validMonths {int}
     * @param value {string}
     */
    function setCookie(name, validMonths, value) {
        const cookie_valid_until = new Date();
        cookie_valid_until.setMonth(cookie_valid_until.getMonth() + validMonths);
        // todo add ; secure
        document.cookie = `${name}=${value}; expires=${cookie_valid_until.toUTCString()}; path=/`;
    }

    /**
     *
     * @param name {string}
     * @return {string|null}
     */
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1'); }
        const match = document.cookie.match(RegExp(`(?:^|;\\s*)${escape(name)}=([^;]*)`));
        return match ? match[1] : null;
    }
}
